module.exports = __webpack_public_path__ + "img/r5.5598b868.jpg";